var map = {
	"./article-create.svg": 168,
	"./article-ranking.svg": 7796,
	"./article.svg": 6178,
	"./change-theme.svg": 2909,
	"./chart.svg": 5768,
	"./close.svg": 7766,
	"./dashboard.svg": 1470,
	"./example.svg": 1047,
	"./exit-fullscreen.svg": 1209,
	"./eye-open.svg": 3345,
	"./eye.svg": 6177,
	"./fullscreen.svg": 379,
	"./guide.svg": 1150,
	"./hamburger-closed.svg": 3666,
	"./hamburger-opened.svg": 8590,
	"./international.svg": 1491,
	"./introduce.svg": 5470,
	"./language.svg": 9141,
	"./link.svg": 6248,
	"./nested.svg": 62,
	"./password.svg": 441,
	"./permission.svg": 1172,
	"./personnel-info.svg": 4029,
	"./personnel-manage.svg": 6863,
	"./personnel.svg": 9440,
	"./reward.svg": 8285,
	"./role.svg": 3845,
	"./search.svg": 8115,
	"./table.svg": 8637,
	"./tree.svg": 6012,
	"./user.svg": 387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;